function Wellen() {
  return (
    <>
      <div className="wasser-container versteckt">
        <div className="wasser wasser--1"></div>
        <div className="wasser wasser--2"></div>
        <div className="wasser wasser--3"></div>
        <div className="wasser wasser--4"></div>
      </div>
      <div className="wellen-container versteckt">
        <div className="welle welle--1"></div>
        <div className="welle welle--2"></div>
        <div className="welle welle--3"></div>
        <div className="welle welle--4"></div>
      </div>
    </>
  );
}

export default Wellen;
